module.exports = __webpack_public_path__ + "img/applyBanner.fcaf1ae9.png";